import React, { useEffect, useState } from "react";
import { Loader, Toast, Modal } from "../../../..";
import { get } from "../../../../../Utils/axios";
import BookingDetails from "./details";
import Flights from "./flights";
import BookedFor from "../bookedFor";
import FlightCancellation from "./cancellation";
import DownloadTicket from "./downloadTicket";

function FlightBooking({ bookingId, onReload = () => {}, onClose = () => {} }) {
	const [Loading, setLoading] = useState(true);
	const [Booking, setBooking] = useState({});

	//To reload all bookings if polling changed the status
	const [IsUpdated, setIsUpdated] = useState(false);

	const { id, date, amount, airlineCode, flightNumber, departureCode, departureTime, arrivalCode, arrivalTime, type, booking, pnr, bookRefNo, ticket, status, createdAt, updatedAt, userId, maker, flightToPassengers, duration, support_phone, support_email } = Booking;
	const { cancellations, contact, files, flights, fwd_txns, rev_txns, isInternational, meta, payment, travellers, tripId, currency } = booking || {};

	const { airports, airlines } = meta || {};
	let pollingTimeout;

	useEffect(() => {
		if (bookingId) {
			fetchBooking(bookingId);
		}
		// Clear the polling timeout
		return () => {
			clearTimeout(pollingTimeout);
		};
	}, [bookingId]);

	const fetchBooking = (bookingId) => {
		setLoading(true);
		get(`/bookings/flight/${bookingId}`, {}, (r, e) => {
			if (r) {
				setBooking(r);
				if (r.status === "PENDING") {
					pollingTimeout = setInterval(() => {
						pollBooking(bookingId);
					}, 5000);
				}
				setLoading(false);
			} else if (e) {
				Toast.handleError(e);
				setLoading(false);
			}
		});
	};

	const pollBooking = (bookingId) => {
		get(`/bookings/flight/${bookingId}`, {}, (r, e) => {
			if (r) {
				if (r.status !== "PENDING") {
					clearInterval(pollingTimeout);
					setBooking((prev) => ({
						...prev,
						...r,
					}));
					setIsUpdated(true);
				}
			}
		});
	};

	return (
		<>
			<Modal
				open={bookingId}
				onClose={() => {
					//Reload flight bookings to get new status
					if (IsUpdated) {
						onReload();
					}
					onClose();
				}}
			>
				<div className="p-4 rounded-lg bg-light">
					<Loader loading={Loading} />
					<div className="rounded-lg shadow-md bg-canvas">
						<Flights {...{ flights, airports, duration, departureCode, arrivalCode }} />
						<BookingDetails {...{ flights, pnr, bookRefNo, amount, id, status, payment, currency, travellers }} />
					</div>
					<BookedFor type="flight" bookingId={bookingId} travellers={flightToPassengers ? flightToPassengers.map((flight) => flight.passenger || flight.guest) : []} onReload={() => fetchBooking(bookingId)} />
					{status?.toLowerCase() === "booked" && (
						<div className="flex mt-4 gap-x-2">
							<DownloadTicket booking={{ ...booking, pnr, maker, passengers: flightToPassengers, bookingId, bookRefNo, support_phone, support_email }} />
							{!booking.isImported && status === "booked" && (
								<FlightCancellation
									bookingId={bookingId}
									onCancel={() => {
										fetchBooking(bookingId);
										setIsUpdated(true);
									}}
								/>
							)}
						</div>
					)}
				</div>
			</Modal>
		</>
	);
}

export default FlightBooking;
